import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "replyDetails", "reportDetails"]
  static values = {
    copyText: String
  }

  toggle(event) {
    if (event.target.closest("a, .comment-card__time-button, .comment-card__menu, .comment-card__likes")) {
      return
    }

    this.setMenuVisible(this.menuTarget.classList.contains("is-hidden"))
  }

  close() {
    this.setMenuVisible(false)
  }

  closeOnOutsideClick(event) {
    if (this.element.contains(event.target)) {
      return
    }

    this.close()
  }

  toggleReply(event) {
    event.preventDefault()
    event.stopPropagation()

    if (!this.hasReplyDetailsTarget) {
      this.close()
      return
    }

    const shouldOpen = !this.replyDetailsTarget.open

    this.replyDetailsTarget.open = shouldOpen
    this.close()

    if (!shouldOpen) {
      return
    }

    requestAnimationFrame(() => {
      const textarea = this.replyDetailsTarget.querySelector("textarea")
      textarea?.focus()
      textarea?.setSelectionRange(textarea.value.length, textarea.value.length)
    })
  }

  toggleReport(event) {
    event.preventDefault()
    event.stopPropagation()

    if (!this.hasReportDetailsTarget) {
      this.close()
      return
    }

    const shouldOpen = !this.reportDetailsTarget.open

    this.reportDetailsTarget.open = shouldOpen
    this.close()

    if (!shouldOpen) {
      return
    }

    requestAnimationFrame(() => {
      const select = this.reportDetailsTarget.querySelector("select")
      const textarea = this.reportDetailsTarget.querySelector("textarea")

      if (select) {
        select.focus()
      } else {
        textarea?.focus()
      }
    })
  }

  async copy(event) {
    event.preventDefault()
    event.stopPropagation()

    const text = this.copyTextValue.toString()
    if (text.length === 0) {
      this.close()
      return
    }

    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
    } else {
      const fallback = document.createElement("textarea")
      fallback.value = text
      fallback.setAttribute("readonly", "")
      fallback.style.position = "absolute"
      fallback.style.left = "-9999px"
      document.body.appendChild(fallback)
      fallback.select()
      document.execCommand("copy")
      fallback.remove()
    }

    this.close()
  }

  setMenuVisible(visible) {
    if (!this.hasMenuTarget) {
      return
    }

    this.menuTarget.classList.toggle("is-hidden", !visible)
  }
}
